import { CloseIcon } from '@chakra-ui/icons';
import { ButtonProps, IconButton } from '@chakra-ui/react';
import React from 'react';

interface MainNavigationCloseButtonProps extends Pick<ButtonProps, 'display'> {
  onClick: () => void;
}

const CloseButton: React.FC<MainNavigationCloseButtonProps> = ({
  onClick,
  ...rest
}) => {
  return (
    <IconButton
      variant="ghost"
      aria-label="Close Menu"
      onClick={onClick}
      icon={<CloseIcon />}
      zIndex={15}
      {...rest}
    />
  );
};

export default CloseButton;
